var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeanIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118.093,
    height: 140.019,
    viewBox: "0 0 118.093 140.019",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-675.206 -498)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(675.206 498)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 20.318)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M690.162,135.9c-2.426,1.992-10.009,20.69-10.009,20.69l-17.1,10.153-8.536-19.664s15.741-30.051,16.468-31.642c.534-1.167,7.254.165,10.792.958a11.672,11.672,0,0,1,4.019,1.73c3.7,2.508,11.6,8.308,11.681,12.192Z",
    transform: "translate(-627.787 -114.975)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M685.02,115.294c-2.739,2.285-22.107,19.73-22.107,19.73l-20.1,19.035a2.249,2.249,0,0,0-.19,3.245,2.642,2.642,0,0,0,2.867.507,2.994,2.994,0,0,0,.787-.462l22.943-19.187-.021-.009,14.943-7.82S687.761,113.006,685.02,115.294Z",
    transform: "translate(-642.014 -114.849)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M678.566,122.311c.633,2.431,4.423,20.626,4.423,20.626l3.433,19.619a2.673,2.673,0,0,1-1.633,2.612,1.854,1.854,0,0,1-2.238-.246,1.388,1.388,0,0,1-.289-.543L676.971,144l.017,0L671,123.294S677.931,119.88,678.566,122.311Z",
    transform: "translate(-609.033 -107.622)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M676.617,148.1l-15.751,34.3-10.078,31.422a3.459,3.459,0,0,1-3.938,2.6,3.83,3.83,0,0,1-2.523-4.752l8.483-33.143,13.013-47.3.445-1.236Z",
    transform: "translate(-639.537 -97.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M678.338,120.586l-8.844-.321",
    transform: "translate(-610.747 -108.956)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M668.367,138.633",
    transform: "translate(-612.029 -88.056)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M657.952,136.632l6.9,39.234-.77,32.794a3.392,3.392,0,0,0,2.888,3.679,3.9,3.9,0,0,0,3.966-3.7l2.854-33.919,2.414-39.6-.017-1.3Z",
    transform: "translate(-623.88 -93.532)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(107.355 87.837)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M692.231,196.547V146.558h4.99v49.989a2.192,2.192,0,0,1-2.193,2.193h-.6A2.192,2.192,0,0,1,692.231,196.547Z",
    transform: "translate(-692.231 -146.558)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.868 80.709)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 51.225,
    height: 4.989,
    rx: 0.969
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.752 87.837)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M676.045,196.547V146.558h4.99v49.989a2.192,2.192,0,0,1-2.193,2.193h-.6A2.193,2.193,0,0,1,676.045,196.547Z",
    transform: "translate(-676.045 -146.558)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 12.009,
    cy: 12.009,
    rx: 12.009,
    ry: 12.009,
    transform: "translate(53.885 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeanIcon);
export default __webpack_public_path__ + "static/media/LeanIcon.2d9fde6a0f0435abd0f8c380c00b9013.svg";
export { ForwardRef as ReactComponent };